'use client';

import { PrismicRichText } from '@prismicio/react';
import { type RichTextField } from '@prismicio/client';

import {
  BaselineConfiguration,
  useRetainableSearchParamsContext,
} from '@preventx/prismic-services';
import { Heading } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

type RichTextHeroProps = {
  content: RichTextField;
};

export const RichTextHero = ({ content }: RichTextHeroProps) => {
  const { searchParams } = useRetainableSearchParamsContext();

  const { WebsiteUrl } = applicationEnv();

  const configuration = BaselineConfiguration({
    websiteUrl: WebsiteUrl,
    searchParams: searchParams,
  });

  return (
    <PrismicRichText
      field={content}
      components={{
        ...configuration,
        heading1: ({ children }) => (
          <Heading component="h1" addHeroTitle>
            {children}
          </Heading>
        ),
      }}
    />
  );
};
